<template>
  <div>
    <div v-if="canRenderDownloadButton" class="st-apexchart-download-row">
      <download-button
        :label="downloadLabel"
        :download-type="downloadType"
        :file-name="downloadFileName"
        :on-download="onDownload"
        :button-attributes="downloadButtonAttributes"
        :disabled="downloadDisabled"
      ></download-button>
    </div>
    <apexchart
      :key="apexRefreshKey"
      v-bind="$attrs"
      v-on="$listeners"
      :type="type"
      :height="height"
      :width="width"
      :options="resolvedOptions"
      :series="resolvedSeries"
    ></apexchart>
    <div v-if="rangeSliderActive" style="padding: 4px 10px 0;">
      <v-layout align-center>
        <v-btn icon small flat :disabled="clampedViewStart === 0" @click="panLeft">
          <v-icon small>chevron_left</v-icon>
        </v-btn>
        <v-flex>
          <v-slider
            v-model="viewStartIndex"
            :min="0"
            :max="sliderMax"
            :step="1"
            hide-details
            color="primary"
            style="margin-top: 0"
          ></v-slider>
        </v-flex>
        <v-btn icon small flat :disabled="clampedViewStart >= sliderMax" @click="panRight">
          <v-icon small>chevron_right</v-icon>
        </v-btn>
      </v-layout>
      <div style="text-align: center; font-size: 11px; color: #888; margin-top: -2px;">
        Showing {{ viewSlice.start + 1 }}–{{ viewSlice.end }} of {{ totalDataPoints }}
      </div>
    </div>
  </div>
</template>

<script>
import src from './src'
export default src
</script>

<style scoped>
.st-apexchart-download-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
